import React, { useEffect } from 'react';
import { Card, Icon } from 'components';

const Contact = () => {

  useEffect(() => {
    window.scroll({
      top: 0, 
      left: 0, 
      behavior: 'smooth'
    });
  }, [])
  
  return (
    <Card>
      <Card.Header>
        <b className="title">Contacts</b>
      </Card.Header>
      <Card.Body>
        <div className="flex flex-col xl:flex-row lg:flex-row -mt-5">
          <div className="w-full xl:w-1/4 lg:w-1/4 flex p-5 border-r-0 xl:border-r-2 lg:border-r-2 border-gray-300  justify-center">
            <ul className="flex-col space-y-5">
              <li className="flex space-x-3">
                <span className="border w-5 h-5 border-primary rounded-full flex items-center justify-center">
                  <Icon.Phone />
                </span>
                <span >02-123-4567</span>
              </li>
              <li className="flex space-x-3">
                <span className="border w-5 h-5 border-primary rounded-full flex items-center justify-center">
                  <Icon.Cellphone />
                </span>
                <span >+63999-999-9999</span>
              </li>
              <li className="flex space-x-3">
                <span className="border w-5 h-5 border-primary rounded-full flex items-center justify-center">
                  <Icon.Envelope />
                </span>
                <span >ltfrb@email.com</span>
              </li>
            </ul>
          </div>
          <div className="flex-1 p-5 ">
            
            <iframe 
              title="LTFRB location"
              className="w-full h-full" 
              style={{ height: 500 }}
              src="https://maps.google.com/maps?q=Macdouton%20Building%2C%20768%20Edsa%20Cor%20East%20Avenue%2C%20Diliman%2C%20Quezon%20City%2C%201100%20Metro%20Manila&t=&z=13&ie=UTF8&iwloc=&output=embed" 
              frameborder="0" 
              scrolling="no" 
              marginheight="0" 
              marginwidth="0" />

          </div>
        </div>
      </Card.Body>
    </Card>
  )
}


export default Contact